const basePath = '/assets/pixi-bingo/'

export const path = {
  imagePath: basePath + 'images/',
  spinePath: basePath + 'spine/',
  fontsPath: basePath + 'fonts/'
}

const width = window.screen.availWidth
const isDesktop = width > 1024
const isTablet = width >= 768 && width < 1024


export const settings = {
  originalWidth: isDesktop ? 1920 : isTablet ? 1500 : 1200,
  originalHeight: isDesktop ? 870 : isTablet ? 50 : 50,
  currentWidth: isDesktop ? 1920 : isTablet ? 1500 : 1200,
  currentHeight: isDesktop ? 870 : isTablet ? 50 : 50,
  windowWidth: isDesktop ? 1920 : isTablet ? 1500 : 1200,
  windowHeight: isDesktop ? 870 : isTablet ? 50 : 50,
  backgroundColor: 0x000000,
  backgroundAlpha: 1,
  devicePixelRatio: 1.6,
  div: () => document.getElementById('pixi-game'),
  resizeThrottleDelay: 0,
  music: true,
  sound: true,
  vibration: true
}
